import { ImageTag } from "src/app/components/banner/banner.component";
import { HomeContent } from "./home-content.model";

export class Home {
    constructor(
        public primary_banner_section: any[],
        public home_content_sections: HomeContent[],
        public brands: string,
        public categories: string
    ) { }
}

export enum PAGE {
    HOME = 'home',
    CATEGORY = 'category',
    SEARCH = 'search',
    PRODUCTS = 'products'
}

export enum HomeContentType {
    BANNER = 'banner',
    PRODUCT_LIST = 'product_list',
    CATEGORIES = 'categories',
    BRANDS = 'brands',
    PRODUCT_TAGS = 'product_tags',
    PRODUCT_COLLECTIONS = 'collections',
    PRODUCT_COLLECTION = 'product_collection',
    MULTIPLE_BANNER_CAROUSEL = 'multiple_banner_carousel'
}
export class Banner {
    constructor(
        public images: BannerImage[],
        public id: string,
        public title: string,
        public buyer_groups: any[],
        public click_action: ClickAction,
        public home_content: string,
        public is_active: boolean,
        public is_archived: boolean,
        public is_primary_banner_section: boolean,
        public sales_channel: any[],
        public seller_company: string,
        public terms_and_conditions: any,
        public position: number
    ) { }
}


export class ClickAction {
    constructor(
        public value: string,
        public action: ClickActionChoices,
        public url_path: string
    ) { }
}
export class BannerImage {
    constructor(
        public tag: ImageTag,
        public url: string,
        public label: string,
    ) { }
}

export enum ClickActionChoices {
    link_offer = 'link_offer',
    search_keywords = 'search_keywords',
    link_category = 'link_category',
    link_product = 'link_product',
    link_url = 'link_url',
    product_flag = 'product_flag',
    link_brand = 'link_brand',
    link_collection = 'link_collection',
    modal = 'modal',
    internal_page = 'internal_page',
    page = 'page',
    none = 'none'
}
export interface SelectedProduct {
    id: string;
}

export class Brand {
    constructor(
        public logo?: null,
        public name?: string,
    ) { }
}

export interface CategoryInfo {
    id: string;
    url_path: string;
}